module.exports = __webpack_public_path__ + "img/sala3.05d6c8ec.jpg";